var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkImportLep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6693 18.8334V18.6667C29.6693 17.2666 29.6693 16.5666 29.3968 16.0318C29.1571 15.5614 28.7747 15.1789 28.3042 14.9392C27.7695 14.6667 27.0694 14.6667 25.6693 14.6667H20.3359C18.9358 14.6667 18.2357 14.6667 17.701 14.9392C17.2306 15.1789 16.8481 15.5614 16.6084 16.0318C16.3359 16.5666 16.3359 17.2666 16.3359 18.6667V27.3334C16.3359 28.7335 16.3359 29.4336 16.6084 29.9684C16.8481 30.4388 17.2306 30.8212 17.701 31.0609C18.2357 31.3334 18.9358 31.3334 20.3359 31.3334H23.4193M23.4193 22.1667H19.6693M22.5859 25.5001H19.6693M26.3359 18.8334H19.6693M28.0026 28.0001V23.4167C28.0026 22.7264 28.5622 22.1667 29.2526 22.1667C29.943 22.1667 30.5026 22.7264 30.5026 23.4167V28.0001C30.5026 29.3808 29.3833 30.5001 28.0026 30.5001C26.6219 30.5001 25.5026 29.3808 25.5026 28.0001V24.6667",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkImportLep);
export default __webpack_public_path__ + "static/media/bulk-import-lep.5180408b1068630f59ae06279c29b526.svg";
export { ForwardRef as ReactComponent };